import styled from '@emotion/styled'

import TemplateChooser from 'components/TemplateChooser'
import { Template } from 'types/template'

const StyledLabel = styled.p`
	${({ theme }) => theme.typography.captionMedium};
`

const StyledFallbackTemplateSection = styled.div`
	flex-shrink: 0;
	margin-bottom: ${({ theme }) => theme.spaces.space6};
	max-width: 360px;
`

type FallbackTemplateSectionProps = {
	templates: Template[]
	value: string
	onChange: (value: string) => void
}

function FallbackTemplateSection({ templates, value, onChange }: FallbackTemplateSectionProps) {
	return (
		<StyledFallbackTemplateSection>
			<StyledLabel>If a customer doesn&apos;t match any rule above, display:</StyledLabel>
			<TemplateChooser
				templates={templates}
				controlled={{
					value,
					onChange: (value) => onChange(value),
				}}
				dropdownPosition="top"
				elevated
			/>
		</StyledFallbackTemplateSection>
	)
}

export default FallbackTemplateSection
